var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_tabc2", style: { width: _vm.width, height: _vm.height } },
    [
      _vm.$slots.top
        ? _c("div", { staticClass: "_tabcb border-bottom" }, [_vm._t("top")], 2)
        : _vm._e(),
      _c(
        "div",
        {
          ref: "main",
          staticClass: "_tabcp",
          class: _vm.hideOverflow ? "_tabch" : void 0,
          on: {
            touchstart: _vm.scrollReset,
            wheel: _vm.scrollReset,
            scroll: _vm.scroll,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm.$slots.bottom
        ? _c("div", { staticClass: "_tabcb border-top" }, [_vm._t("bottom")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }